module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-205.344066df.svg";